import LeadsServices from "./Services/LeadsServices";
import Footer from "../../components/Footer";
import LeadsForm from "./LeadsForm/LeadsForm";
import "./LeadsPage.css";

const LeadsPage = ({heroRef}) => {
  return (
    <div ref={heroRef}>
      <div className="leads_page_content">
        <LeadsForm />
      </div>
      <LeadsServices />
      <Footer />
    </div>
  );
};
export default LeadsPage;
